import { render, staticRenderFns } from "./CardPurchaseItems.vue?vue&type=template&id=b9ecdd66"
import script from "./CardPurchaseItems.vue?vue&type=script&lang=js"
export * from "./CardPurchaseItems.vue?vue&type=script&lang=js"
import style0 from "./CardPurchaseItems.vue?vue&type=style&index=0&id=b9ecdd66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports